

<div style="width: 75vw;">
    
    <p-tabView>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <span class="tab-header">
                    New
                    <p-badge 
                        *ngIf="(unopenedReferralIds$ | async)?.length ?? 0 > 0" 
                        [value]="(unopenedReferralIds$ | async)?.length"
                        severity="info"
                        styleClass="ml-2 new-badge">
                    </p-badge>
                </span>
            </ng-template>
            <p-card>
                <div class="surface-card p-4 shadow-2 border-round p-fluid">
                <p-table 
                    *ngIf="(newReferrals$ | async)" 
                    [value]="(newReferrals$ | async) || [] "
                    [rowHover]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Id</th>
                            <th>Status</th>
                            <th>Injured Worker</th>
                            <th>Category</th>
                            <th>Adjuster</th>
                            <th>Carrier</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-referral let-index="rowIndex">
                        <tr [class.highlight-row]="unopenedReferralIds.includes(referral.id)">
                            <td>{{ referral.id }}</td>
                            <td>{{ referral.status }}</td>
                            <td>{{ referral.patientName}}</td>
                            <td>{{ referral.procedureCategory }}</td>
                            <td>{{ referral.adjusterName }}</td>
                            <td>{{ referral.carrierName }}</td>
                            <td>
                                <p-button icon="pi pi-folder" [text]="true" pTooltip="Open" (onClick)="referralSelected(referral)"></p-button>
                                <p-button icon="pi pi-times" [text]="true" pTooltip="Close" (onClick)="closeOverlay.toggle($event)" severity="danger"></p-button>
                                <p-overlayPanel #closeOverlay>
                                    <p-dropdown
                                        [options]="(closureReasons$ | async) ?? []"
                                        optionLabel="description" 
                                        placeholder="Closure Reason" 
                                        (onChange)="closeReferral(referral, $event.value)">
                                    </p-dropdown>
                                </p-overlayPanel>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <p-dialog  [(visible)]="visibility" [closable]="true" [modal]="true"  [style]="{width: '50vw', height:'100vh',position:'absolute',right:'1vw' }"
                            (onHide)="referralDialogClosed()">
                    <p-blockUI [target]="editorNew" [blocked]="waiting">
                        <i class="pi pi-spin pi-spinner" style="font-size: 8rem"></i>
                    </p-blockUI>
                    <p-panel #editorNew>
                        <app-referral-editor [referral]="(selectedReferral$ | async)" [encounter]="(selectedReferralEncounter$ | async)" (cancelled)="visibility=false" (saved)="referralUpdated($event)"></app-referral-editor>
                    </p-panel>
                </p-dialog>
                </div>
            </p-card>
        </p-tabPanel>
        <p-tabPanel header="Reviewed">
            <p-card>
                <div class="surface-card p-4 shadow-2 border-round p-fluid">

                    <p-table 
                        *ngIf="(reviewedReferrals$ | async)" 
                        [value]="reviewedReferrals"
                        [rowHover]="true">
                        <ng-template>

                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Id</th>
                                <th>Injured Worker</th>
                                <th>Category</th>
                                <th>Carrier</th>
                                <th>Recipient</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-referral let-index="rowIndex">
                            <tr>
                                <td>{{ referral.id }}</td>
                                <td>{{ referral.patientName}}</td>
                                <td>{{ referral.procedureCategory }}</td>
                                <td>{{ referral.carrierName }}</td>
                                <td>
                                    <div class="flex align-items-center">
                                        <span>
                                            <p-inplace #recipientEditor [closable]="true" closeIcon="pi pi-check" (onDeactivate)="contractSignerChanged(referral)">
                                                <ng-template pTemplate="display">
                                                    <span>{{referral.selectedAdjusterName}}</span>
                                                </ng-template>
                                                <ng-template pTemplate="content">
                                                    <span>
                                                        <p-dropdown appendTo="body" [(ngModel)]="referral.selectedContractApprover" [options]="referral.availableContractRecipients" optionLabel="displayValue" optionValue="adjuster" placeholder="Select Approver">
                                                        </p-dropdown>
                                                    </span>
                                                </ng-template>
                                            </p-inplace>
                                        </span>
                                        
                                        <span><p-button *ngIf="!recipientEditor.active" icon="pi pi-pencil" (click)="recipientEditor.activate()"></p-button></span>
                                    </div>
                                </td>
                                <td>
                                    <div>

                                        <div>
                                            <p-button icon="pi pi-undo" [text]="true" pTooltip="Re-Review" (onClick)="placeInReview(referral)"></p-button>
                                            <p-button icon="pi pi-folder-open" [text]="true" pTooltip="Open" (onClick)="openEncounter(referral)" > </p-button>
                                            <p-button icon="pi pi-times" [text]="true" pTooltip="Close" (onClick)="closeOverlay.toggle($event)" severity="danger"></p-button>
                                            <p-button *ngIf="referral.authorization" icon="pi pi-search" [text]="true" pTooltip="View Approval" (onClick)="viewContractPdf(referral)"></p-button>

                                            <p-overlayPanel #closeOverlay>
                                                <p-dropdown
                                                    [options]="(closureReasons$ | async) ?? []"
                                                    optionLabel="description" 
                                                    placeholder="Closure Reason" 
                                                    (onChange)="closeReferral(referral, $event.value)">
                                                </p-dropdown>
                                            </p-overlayPanel>
                                            <p-dialog header = "PDF Viewer" [(visible)]="displayPdfDialog" [modal]="true" (onHide)="onDialogHide()">
                                                <ng-container *ngIf="currentPdfUrl">
                                                    <iframe [src]="currentPdfUrl" width="1200" height="800" style="border: none;"></iframe>
                                                </ng-container>
                                            </p-dialog>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="flex w-12">
                                        <p-button *ngIf="!referral.authorization && referral.selectedContractApprover" [raised]="true" label="Create Auth" (onClick)="createContractPdf(referral)" [disabled]="(creatingReferrals$ | async)?.includes(referral.id)">
                                            <ng-template pTemplate="icon">
                                                <i *ngIf="(creatingReferrals$ | async)?.includes(referral.id)" class="pi pi-spin pi-cog" style="font-size: 1rem"></i>
                                            </ng-template>
                                        </p-button>

                                        <p-button *ngIf="referral.authorization" [raised]="true" label="Send Approval" (onClick)="sendReferralForApproval(referral)" [disabled]="(authorizingReferrals$ | async)?.includes(referral.id)">
                                            <ng-template pTemplate="icon">
                                                <i *ngIf="!(authorizingReferrals$ | async)?.includes(referral.id)" class="pi pi-thumbs-up" style="font-size: 1rem"></i>
                                                <i *ngIf="(authorizingReferrals$ | async)?.includes(referral.id)" class="pi pi-spin pi-cog" style="font-size: 1rem"></i>
                                            </ng-template>
                                        </p-button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-card>
        </p-tabPanel>
        <p-tabPanel header="Awaiting Approval">
            <p-card>
                <div class="surface-card p-4 shadow-2 border-round p-fluid">

                    <p-table 
                        *ngIf="(submittedForApprovalReferrals$ | async)" 
                        [value]="(submittedForApprovalReferrals$ | async) || [] "
                        [rowHover]="true">
                        <ng-template>

                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Id</th>
                                <th>Injured Worker</th>
                                <th>Request Date</th>
                                <th>Category</th>
                                <th>Adjuster</th>
                                <th>Carrier</th>
                                <th>Auth Link</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-referral let-index="rowIndex">
                            <tr>
                                <td>{{ referral.id }}</td>
                                <td>{{ referral.patientName}}</td>
                                <td>{{ referral.approvalRequestDate | date:'shortDate' }}</td>
                                <td>{{ referral.procedureCategory }}</td>
                                <td>{{ referral.adjusterName }}</td>
                                <td>{{ referral.carrierName }}</td>
                                <td>{{referral.adjusterApprovalLink}}</td>
                                <td>
                                    <p-button icon="pi pi-folder-open" [text]="true" (onClick)="openEncounter(referral)" > </p-button>
                                    <p-button icon="pi pi-times" [text]="true" pTooltip="Close" (onClick)="closeOverlay.toggle($event)" severity="danger"></p-button>
                                    <p-overlayPanel #closeOverlay>
                                        <p-dropdown
                                            [options]="(closureReasons$ | async) ?? []"
                                            optionLabel="description" 
                                            placeholder="Closure Reason" 
                                            (onChange)="closeReferral(referral, $event.value)">
                                        </p-dropdown>
                                    </p-overlayPanel>
                                </td>
                                <td>
                                    <p-button [raised]="true" label="Re-Send Approval" (onClick)="reSendReferralForApproval(referral)" [disabled]="(authorizingReferrals$ | async)?.includes(referral.id)">
                                        <ng-template pTemplate="icon">
                                            <i *ngIf="!(authorizingReferrals$ | async)?.includes(referral.id)" class="pi pi-thumbs-up" style="font-size: 1rem"></i>
                                            <i *ngIf="(authorizingReferrals$ | async)?.includes(referral.id)" class="pi pi-spin pi-cog" style="font-size: 1rem"></i>
                                        </ng-template>
                                    </p-button>
                                    <p-button [raised]="true" label="Edit" [text]="true" pTooltip="Open" (onClick)="referralSelected(referral)"></p-button>
                                    <p-dialog  [(visible)]="visibility" [closable]="true" [modal]="true"  [style]="{width: '50vw', height:'100vh',position:'absolute',right:'1vw' }"
                                            (onHide)="referralDialogClosed()">
                                        <p-blockUI [target]="editorAwaiting" [blocked]="waiting">
                                            <i class="pi pi-spin pi-spinner" style="font-size: 8rem"></i>
                                        </p-blockUI>
                                        <p-panel #editorAwaiting>
                                            <app-referral-editor [referral]="(selectedReferral$ | async)" [encounter]="(selectedReferralEncounter$ | async)" (cancelled)="visibility=false" (saved)="referralUpdated($event)"></app-referral-editor>
                                        </p-panel>
                                    </p-dialog>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-card>
        </p-tabPanel>
        <p-tabPanel header="Recently Closed">
            <p-card>
                <div class="surface-card p-4 shadow-2 border-round p-fluid">

                    <p-table 
                        *ngIf="(recentlyClosedReferrals$ | async)" 
                        [value]="(recentlyClosedReferrals$ | async) || [] "
                        [rowHover]="true">
                        <ng-template>

                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Id</th>
                                <th>Injured Worker</th>
                                <th>Category</th>
                                <th>Carrier</th>
                                <th>Adjuster</th>
                                <th>Closure Reason</th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-referral let-index="rowIndex">
                            <tr>
                                <td>{{ referral.id }}</td>
                                <td>{{ referral.patientName}}</td>
                                <td>{{ referral.procedureCategory }}</td>
                                <td>{{ referral.carrierName }}</td>
                                <td>{{ referral.adjusterName }}</td>
                                <td>{{ (closureReasonMap$| async)?.[referral.closureReason] }}</td>
                                <td><p-button icon="pi pi-folder-open" [text]="true" (onClick)="openEncounter(referral); placeInReview(referral)" > </p-button></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-card>
        </p-tabPanel>
    </p-tabView>
</div>

